<script setup lang="ts">
import { computed } from 'vue'
import { ParagraphText, ParagraphTwoColumnText } from '~/api/graphql/generated'

const props = defineProps<{
  entity: ParagraphTwoColumnText
}>()

const columnTexts = computed(() => {
  return (
    props.entity.fieldColumnItems?.map((item) => {
      const columnText = item?.entity as ParagraphText
      return columnText?.fieldText?.processed || ''
    }) || []
  )
})
</script>

<template>
  <Section v-animate="{ animation: 'vertical-reveal' }">
    <ul class="items cul t-10 t-o-1 tl-12 tl-o-0 ds-10 ds-o-1">
      <li v-for="(text, index) in columnTexts" :key="index" v-html="text" />
    </ul>
  </Section>
</template>

<style scoped lang="scss">
.items {
  display: grid;
  gap: var(--gap);

  @include breakpoint(tl) {
    grid-template-columns: 1fr 1fr;
  }
}
</style>
